// extracted by mini-css-extract-plugin
export default {"modal-body":"modal-body-StPiCMw","loading-wrapper":"loading-wrapper-cakWxcQ"};